import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';

import {
    FETCH_EXERCISE_TYPES,
    FETCH_EXERCISE_TYPES_FETCHING,
    FETCH_EXERCISE_TYPES_SUCCESS,
    FETCH_EXERCISE_TYPES_FAIL
} from '../actions/ActionTypes';
import { SportTypes } from 'WorkoutPage/constants/WorkoutConstants';

export function* fetchExerciseTypes(action) {
    try {
        yield put({
            type: FETCH_EXERCISE_TYPES_FETCHING
        });

        let fileName;
        const fileType = action.showWheelchairExercises ? 'WithWheelchair' : '';
        switch (action.sportType) {
            case SportTypes.Mobility:
                fileName = 'Mobility';
                break;
            case SportTypes.Pilates:
                fileName = 'Pilates';
                break;
            case SportTypes.Yoga:
                fileName = 'Yoga';
                break;
            case SportTypes.Strength_Training:
            case SportTypes.Cardio:
            case SportTypes.Hiit:
            default:
                fileName = 'Exercises';
                break;
        }
        const url = `/web-data/exercises/${fileName}${fileType}.json`;
        const response = yield call(axios.get, url, { baseURL: '/' });

        yield put({
            type: FETCH_EXERCISE_TYPES_SUCCESS,
            exerciseTypesData: response.data,
            fullLocale: action.fullLocale,
            sportType: action.sportType
        });
    } catch (e) {
        yield put({
            type: FETCH_EXERCISE_TYPES_FAIL,
            exerciseTypesData: {}
        });
    }
}

export const exerciseTypesSagas = [takeEvery(FETCH_EXERCISE_TYPES, fetchExerciseTypes)];
